import { render } from "./GridContracteMunca.vue?vue&type=template&id=0f1c3f65&ts=true"
import script from "./GridContracteMunca.vue?vue&type=script&lang=ts"
export * from "./GridContracteMunca.vue?vue&type=script&lang=ts"

import "./GridContracteMunca.vue?vue&type=style&index=0&id=0f1c3f65&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__